import React from 'react';
import { ActionOperationType, ActionRef } from 'further-types/lp/action';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import ReviewContent from './ReviewContent';
import ErrorBoundary from 'components/ErrorBoundary';
import FormWrapper from './FormWrapper';

type Props = {
  vehicleId: string;
  bankAccountId: string;
  bankName: string;
  bankOperation: {
    id: string;
    spent?: number;
    received?: number;
    accountCurrency: CurrencyCode;
    date: CalendarDay;
  };
  selectedTransactions: Array<{
    id: string;
    splitFromTransactionId?: string;
    unreconciledAmountTcy: number;
    operationType: ActionOperationType;
    currencyCode: CurrencyCode;
    actionRef: ActionRef;
    ledgerDate: CalendarDay;
  }>;
  onClose: () => void;
};

const Review: React.FC<Props> = ({
  vehicleId,
  bankAccountId,
  bankName,
  bankOperation,
  selectedTransactions,
  onClose,
}) => {
  return (
    <ErrorBoundary>
      <FormWrapper>
        <ReviewContent
          vehicleId={vehicleId}
          bankAccountId={bankAccountId}
          bankName={bankName}
          bankOperation={bankOperation}
          selectedTransactions={selectedTransactions}
          onClose={onClose}
        />
      </FormWrapper>
    </ErrorBoundary>
  );
};

export default Review;
